<login-header></login-header>


<div class="press-hero" style="background-image: url('/assets/images/press-hero.webp');">
    <div class="head-foot-width text-center">
        <div class="press-content">
            <h1>News and Articles</h1>
        </div>
    </div>
</div>
<div class="articles-section">
    <div class="content-width">
        <div class="article-grid">

            <div class="single-article">
                <a class="article-link" href="http://voyagemia.com/interview/hidden-gems-meet-jason-brown-of-family-central/" target="_blank" rel="noopener noreferrer" title="Opens new window">
                    <div class="article-image">
                        <img src="/assets/images/VoyageMIA-logo.png" alt="VoyageMIA logo">
                    </div>
                    <p class="pub-date">June 16, 2022</p>
                    <h2 class="article-title">Hidden Gems: Meet Jason Brown</h2>
                </a>
            </div>

            <div class="single-article">
                <a class="article-link" href="https://www.forbes.com/sites/forbestechcouncil/2022/06/10/how-to-inspire-employees-to-care-about-cybersecurity/?sh=2ab496605e0a" target="_blank" rel="noopener noreferrer" title="Opens new window">
                    <div class="article-image">
                        <img src="/assets/images/forbes-logo.png" alt="forbes logo">
                    </div>
                    <p class="pub-date">June 10, 2022</p>
                    <h2 class="article-title">How To Inspire Employees To Care About Cybersecurity</h2>
                </a>
            </div>

            <div class="single-article">
                <a class="article-link" href="https://www.entrepreneur.com/listen/entrepreneur-weekly" target="_blank" rel="noopener noreferrer" title="Opens new window">
                    <div class="article-image">
                        <img src="/assets/images/eweekly-logo.png" alt="Entrepreneur Weekly logo">
                    </div>
                    <p class="pub-date">June 04, 2022</p>
                    <h2 class="article-title">Following Your Passion with Jason Brown and One Foot In Front Of The Other with Simon Leslie</h2>
                </a>
            </div>

            <div class="single-article">
                <a class="article-link" href="https://www.fatherly.com/life/what-im-glad-i-knew-about-myself-before-i-became-a-parent" target="_blank" rel="noopener noreferrer" title="Opens new window">
                    <div class="article-image">
                        <img src="/assets/images/fatherly-logo.png" alt="fatherly logo">
                    </div>
                    <p class="pub-date">May 24, 2022</p>
                    <h2 class="article-title">What I’m Glad I Knew About Myself Before I Became a Dad, According to 12 Men</h2>
                </a>
            </div>

            <div class="single-article">
                <a class="article-link" href="https://medium.com/authority-magazine/making-something-from-nothing-jason-brown-of-family-central-on-how-to-go-from-idea-to-launch-3fd81a8c8ec6" target="_blank" rel="noopener noreferrer" title="Opens new window">
                    <div class="article-image">
                        <img src="/assets/images/medium-logo.png" alt="Medium logo">
                    </div>
                    <p class="pub-date">May 19, 2022</p>
                    <h2 class="article-title">Making Something From Nothing: Jason Brown Of Family Central On How To Go From Idea To Launch</h2>
                </a>
            </div>

            <div class="single-article">
                <a class="article-link" href="https://teach.ceoblognation.com/2022/04/22/25-entrepreneurs-define-innovation-and-disruption/" target="_blank" rel="noopener noreferrer" title="Opens new window">
                    <div class="article-image">
                        <img src="/assets/images/CBNation-logo.png" alt="CBNation logo">
                    </div>
                    <p class="pub-date">April 22, 2022</p>
                    <h2 class="article-title">25 Entrepreneurs Define Innovation And Disruption</h2>
                </a>
            </div>
            
        </div>
    </div>
</div>


<app-footer (showPrice)="showPricing()"></app-footer>

<ng-template #pricing>
    <app-pricing (onCancel)="onClose()"></app-pricing>
</ng-template>